import {
  ELEMENT_COLUMN,
  ELEMENT_COLUMN_ITEM,
  ELEMENT_PARAGRAPH,
} from '../../pluginKeys';

export const getDefaultColumnValue = () => ({
  type: ELEMENT_COLUMN,
  children: [
    {
      children: [
        {
          children: [
            {
              text: 'Column 1',
            },
          ],
          type: ELEMENT_PARAGRAPH,
        },
      ],
      type: ELEMENT_COLUMN_ITEM,
      width: 0.5,
    },
    {
      children: [
        {
          children: [
            {
              text: 'Column 2',
            },
          ],
          type: ELEMENT_PARAGRAPH,
        },
      ],
      type: ELEMENT_COLUMN_ITEM,
      width: 0.5,
    },
  ],
});
